<app-trip-cash-splitup [tripData]="data"></app-trip-cash-splitup>
